import { Col, RadioPills, type RadioPillsProperties, Row, Text } from 'ui';
import { type TodoWidgetDate, isTodoWidgetDateKey } from '../../../types';

type P = {
  activeKey: TodoWidgetDate;
  setActiveKey: (key: TodoWidgetDate) => void;
};

const TodosWidgetHeader = ({ activeKey, setActiveKey }: P) => {
  const items: RadioPillsProperties<TodoWidgetDate>['items'] = [
    {
      label: 'Today',
      value: 'today',
    },
    {
      label: 'Tomorrow',
      value: 'tomorrow',
    },
  ];

  return (
    <Row align="middle" className="todos-widget-header" gutter={['sm', 'xxs']}>
      <Col>
        <Text id="tablist-todos" size="small" type="secondary" weight="base">
          To-Dos for
        </Text>
      </Col>
      <Col>
        <RadioPills<TodoWidgetDate>
          items={items}
          marginBottom={false}
          onChange={(event) => {
            const key = event.target.value;
            if (isTodoWidgetDateKey(key)) {
              setActiveKey(key);
            } else {
              console.warn('Unknown date key', key);
            }
          }}
          value={activeKey}
        />
      </Col>
    </Row>
  );
};

export default TodosWidgetHeader;
